// @flow

import React, { Component } from 'react';
import I18n from '../../i18n/I18n';


// -- views
import Select from 'react-select';

export default function LocalizableSelect(props) {
  return (
    <Select
      searchPromptText={I18n.tr('components.select.search_prompt_text')}
      searchingText={I18n.tr('components.select.searching_text')}
      noResultsText={I18n.tr('components.select.no_results_text')}
      clearAllText={I18n.tr('components.select.clear_all_text')}
      clearValueText={I18n.tr('components.select.clear_value_text')}
      // the `{label}` is taken as parameter by our i18n, but should not. Tricks: we set a parameter and set `{label}` again.
      addLabelText={I18n.tr('components.select.add_label_text', { label: '{label}'})}
      placeholder={I18n.tr('components.select.placeholder')}
      disabled={props.readOnly || props.disabled}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./sdk/scripts/components/form/LocalizableSelect.js